import { observer } from 'mobx-react'
import { makeStyles, Theme, createStyles, InputAdornment, MenuItem } from "@material-ui/core";
import { SelectProps as MUISelectProps } from "@material-ui/core";
import { ForwardedRef, forwardRef } from 'react';
import REMSelect from '../../rem-conversion/components/Select';
import { Email } from 'mdi-material-ui';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        icon: {
            padding: theme.spacing(1),
            color: 'rgba(0, 0, 0, 0.54)'
        },
    })
);

interface NotificationRecipientSelectProps extends MUISelectProps {
    value: string | 0;
    onChange: (event: React.ChangeEvent<{
        name?: string;
        value: unknown;
    }>, child: React.ReactNode) => void;
    options: Record<string, string>;
}

const NotificationRecipientSelect = observer(forwardRef((props: NotificationRecipientSelectProps, ref: ForwardedRef<HTMLElement>) => {

    /********* React hooks *********/

    const classes = useStyles();

    /********* Render *********/

    return (
        <REMSelect
            {...props}
            ref={ref}
            value={props.value}
            onChange={props.onChange}
            startAdornment={
                <InputAdornment position="start" className={classes.icon}>
                    <Email />
                </InputAdornment>
            }
        >
            {Object.keys(props.options).map((optionValue, index) => {
                return (
                    <MenuItem key={`option-${index}`} value={optionValue}>
                        {props.options[optionValue]}
                    </MenuItem>
                );
            })}
        </REMSelect>
    );
}));

export default NotificationRecipientSelect;